import { render, staticRenderFns } from "./ChartUsersRegister.vue?vue&type=template&id=1e5af056"
import script from "./ChartUsersRegister.vue?vue&type=script&lang=js"
export * from "./ChartUsersRegister.vue?vue&type=script&lang=js"
import style0 from "./ChartUsersRegister.vue?vue&type=style&index=0&id=1e5af056&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports